{
  "appName": "Grupa RW",
  "loading": "Loading...",
  "nav": {
    "dashboard": "Dashboard",
    "mediaUnits": "Media Unit Catalog",
    "map": "Map",
    "offers": "Offers",
    "clients": "Clients",
    "suppliers": "Suppliers",
    "reservations": "Reservations",
    "packages": "Packages",
    "draft": "Draft",
    "comingSoon": "Coming soon",
    "noAccess": "No access",
    "admin": "Admin",
    "adminPois": "Points of interest",
    "logout": "Log out",
    "user": "User"
  },
  "sidebar": {
    "collapse": "Collapse",
    "expand": "Expand",
    "ariaLabel": "Side navigation",
    "mainMenu": "Main menu"
  },
  "language": {
    "switchLabel": "Change language",
    "pl": "Polski",
    "en": "English"
  },
  "appUpdate": {
    "title": "A new version is available",
    "message": "Refresh the page to see the latest changes. You will stay signed in.",
    "reload": "Refresh"
  },
  "actions": {
    "save": "Save media unit",
    "saving": "Saving...",
    "saved": "Saved!",
    "saveError": "Save error",
    "saveChanges": "Save changes",
    "saveConfirm": "Save",
    "cancel": "Cancel",
    "retry": "Try again",
    "backToCatalog": "Media Unit Catalog",
    "backToDetail": "Media unit details"
  },
  "status": {
    "free": "Free",
    "unknown": "Unconfirmed",
    "option": "Option",
    "reserved": "Reserved",
    "reservedSoft": "Soft reservation",
    "reservedHard": "Hard reservation",
    "sold": "Sold",
    "unavailable": "Unavailable"
  },
  "bool": {
    "yes": "Yes",
    "no": "No"
  },
  "errors": {
    "loadFailed": "Failed to load media units",
    "notFound": "Media unit not found",
    "loadUnitFailed": "Failed to load media unit",
    "backToCatalog": "Back to catalog"
  },
  "error": {
    "generic": "An error occurred",
    "notFound": "Page not found",
    "retry": "Try again",
    "goBack": "Go back",
    "details": "Error details"
  },
  "quickAdd": {
    "toast": {
      "standard": "Added {{addedCount}} to: {{offerName}} — {{totalCount}} total, {{skippedCount}} skipped",
      "allSkipped": "0 added — all already in offer: {{offerName}} — {{totalCount}} total, {{skippedCount}} skipped",
      "openOffer": "Open offer"
    },
    "errors": {
      "forbidden": "No permission for this draft offer",
      "creationForbidden": "Couldn't create the offer — you don't have permission to do that.",
      "campaignNumberExhausted": "Couldn't generate a unique campaign number. Please try again.",
      "addUnitsFailedAfterCreate": "Couldn't add media units to the newly created draft offer."
    }
  },
  "notifications": {
    "bellLabel": "Notifications",
    "markAllRead": "Mark all as read",
    "emptyState": "No notifications",
    "ttlExpiring": "{{count}} offer reservation(s) expiring soon",
    "ttlExpired": "{{count}} offer reservation(s) have expired",
    "queuePromoted": "{{count}} waitlist reservation(s) promoted",
    "offerVersionAccepted": "{{count}} offer(s) accepted by client",
    "offerVersionRejected": "{{count}} offer(s) rejected by client"
  },
  "apiErrors": {
    "generic": "Something went wrong. Please try again.",
    "validationError": "The submitted data is invalid. Check the values you entered.",
    "queryValidationError": "Some data couldn't be loaded. Try refreshing the page.",
    "unauthorized": "Your session has expired. Please sign in again.",
    "forbidden": "You don't have permission to perform this action.",
    "notFound": "The requested resource was not found.",
    "conflict": "A data conflict occurred. Refresh the page and try again.",
    "rateLimited": "Too many requests. Please try again shortly.",
    "internalError": "A server error occurred. Please try again later.",
    "staleState": "This data was changed by someone else. Refresh the page and try again.",
    "reservationConflict": "This date range conflicts with another reservation.",
    "reservationStatusBlocked": "This reservation can't be changed right now due to its status.",
    "offerVersionSuperseded": "This offer version has been superseded by a newer one.",
    "publicLinkExpired": "This offer link has expired.",
    "lockedDecisionModified": "Some selected units are already binding and can't be changed. Refresh the page and try again.",
    "unsupportedFileFormat": "Unsupported file format. Save the file in an allowed format and try again."
  },
  "offerUnits": {
    "addConflictWarning_one": "{{count}} of the added media units has a reservation that conflicts with the campaign duration.",
    "addConflictWarning_other": "{{count}} of the added media units have reservations that conflict with the campaign duration."
  },
  "campaignDurationField": {
    "shortPeriodWarning": "The selected offer period is shorter than 14 days — make sure this is intentional, as most media don't allow reservations shorter than 2 weeks."
  },
  "adminLanding": {
    "heading": "Admin panel",
    "pois": {
      "title": "Geographic data",
      "description": "Manage points of interest (POI) and administrative boundaries, and monitor geographic data imports."
    },
    "permissions": {
      "title": "Permissions",
      "description": "Manage user roles and the permissions matrix."
    },
    "users": {
      "title": "Users",
      "description": "Manage user accounts, roles, and permission overrides."
    },
    "dictionaries": {
      "title": "Dictionaries",
      "description": "Manage media formats and format groups."
    },
    "formatGroups": {
      "title": "Format groups",
      "description": "Manage format groups and their assignment to roles."
    },
    "tags": {
      "title": "Tags",
      "description": "Manage tag definitions — create, edit, and deactivate."
    },
    "featureFlags": {
      "title": "Feature flags",
      "description": "Enable and disable system features without database access."
    }
  }
}
